




























































import Vue from 'vue'

export default Vue.extend({
  name: 'TutorialTrivia',

  methods: {
    dismiss () {
      this.$emit('dismiss')
    },
  },
})
